import * as React from 'react';
import { IPage } from '../../global/state-helpers/page';
import { IArticleElements } from '../models/article-elements'
import { Pagination, IPaginationOptions } from '../../global/components/pagination/pagination';
import { ArticleContentList } from './article-content-list';
import * as queryString from 'query-string'

interface IProps {
    items: IArticleElements[];
    pageModel: IPage;
    newsListing: boolean;
}

// Internal state of the component
interface IState {
    loading: boolean;
    errorText: string;
    currentPage?: number;

}

export class ArticleList extends React.Component<IProps, IState> {
    state: IState = {
        currentPage: this.props.pageModel.page,
        loading: true,
        errorText: null,
    }

    render() {

        const pagination = {
            totalItems: this.props.items.length,
            currentPage: this.state.currentPage,
            pageSize: this.props.pageModel.pageSize,
        } as IPaginationOptions;

        return (
            <div className="paginated-content article-listing-page">
                <p className="article-listing-page-amount">
                    Showing {((this.state.currentPage - 1) * pagination.pageSize) + 1}-{Math.min(this.state.currentPage * pagination.pageSize, this.props.items.length)} of {this.props.items.length} total articles
                </p>
                <ArticleContentList
                    items={this.props.items}
                    currentPage={this.state.currentPage}
                    pageSize={pagination.pageSize}
                    newsListing={this.props.newsListing}
                    />
                <Pagination
                    pagination={pagination}
                    onPageSelect={(page: number) => this.onPageSelect(page, true)}
                    useRedux={false} />
            </div>

        )
    }

    onPageSelect = (page: number, scrollToTop: boolean = false) => {

        this.setState({ currentPage: page });

        if (scrollToTop) {
            window.scroll(0, 0);
        }

        var url = `?${queryString.stringify({ page: page }, { sort: false })}`
        window.history.replaceState(undefined, undefined, url);
    }
}